import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'

export class Hrule extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  get className() {
    const { className } = this.props
    return c('im-hrule', className)
  }

  render() {
    const { className } = this
    return <div className={className} />
  }
}

export default Hrule
